import React, {useEffect, useState} from 'react'
import styles from "./WorkerAmountCard.module.css";
import {UserGroupIcon} from '@heroicons/react/20/solid';
import {workerAmountAPI} from "../../../services/client";
import CreateWorkerRequestPopUp from "../../../views/client/popup/CreateWorkerRequestPopUp";

interface WorkerAmountCardProps {
    onAddClick: () => void;
}

const today = new Date();
// 작업자 수 카드
const WorkerAmountCard: React.FC<WorkerAmountCardProps> = ({onAddClick}) => {
    const [workerCount, setWorkerCount] = useState<number>(0);
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

    useEffect(() => {
        const fetchData = async () => {
            try {
                //이번 달 고용 작업자 수 조회 API
                const workerResponse = await workerAmountAPI();
                setWorkerCount(workerResponse);

            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchData();
    }, []);

    const handleOpenModal = () => {
        setIsModalOpen(true);
        if (onAddClick) {
            onAddClick();
        }
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    return (
        <>
            <div className={styles.container}>
                <div className={styles.headerSection}>
                    <div className={styles.textContainer}>
                        <div className={styles.iconContainer}>
                            <UserGroupIcon className={styles.iconImage}/>
                            <h1>작업자 고용 현황</h1>
                        </div>
                        {/*이번 달*/}
                        <p>{today.getMonth() + 1}월 계약 기준 고용 인원</p>
                    </div>
                </div>
                <div className={styles.bottomSection}>
                    <div className={styles.countText}>
                        {/*작업자 수*/}
                        <span className={styles.countNumber}>{workerCount}명</span>
                        <span className={styles.unit}> / 월</span>
                    </div>
                    {/*작업자 추가 요청 생성 버튼*/}
                    <button
                        onClick={handleOpenModal}
                        className={styles.addButton}
                    >
                        + Add
                    </button>
                </div>
            </div>

            {/*작업자 추가 요청 생성 팝업*/}
            <CreateWorkerRequestPopUp
                isOpen={isModalOpen}
                onClose={handleCloseModal}
            />
        </>
    );
};

export default WorkerAmountCard;